module.exports = __webpack_public_path__ + "img/418917027.bc8d1ba2.jpg";